import Vue from "vue";
import Router from "vue-router";
import i18n from "@/i18n";

import Inscripcion from "@/views/Inscripcion";
import InscripcionIntegra from "@/views/InscripcionIntegra";
import InscripcionCaribe from "@/views/InscripcionCaribe";
import InscripcionNikeCamp from "@/views/InscripcionNikeCamp";
import InscripcionNikeCampEn from "@/views/InscripcionNikeCampEn";
import InscripcionPauGasol from "@/views/InscripcionPauGasol";
import InscripcionNikeCampBCN from "@/views/InscripcionNikeCampBCN";
import InscripcionMundoDeportivo from "@/views/InscripcionMundoDeportivo";
import InscripcionAitana from "@/views/InscripcionAitana";
import InscripcionLiga from "@/views/InscripcionLiga";

Vue.use(Router);

export default new Router({
  mode: "history",
  routes: [
    {
      path: "/inscripcion/:event_id/:lang",
      name: "Inscripcion",
      component: Inscripcion,
      meta: {
        layout: "inscripcion",
      },
      beforeEnter: loadLang,
    },

    {
      path: "/inscripcion/caribe/:event_id/:lang",
      name: "InscripcionCaribe",
      component: InscripcionCaribe,
      meta: {
        layout: "inscripcion",
      },
      beforeEnter: loadLang,
    },

    {
      path: "/inscripcion/integra/:event_id/:lang",
      name: "InscripcionIntegra",
      component: InscripcionIntegra,
      meta: {
        layout: "inscripcion",
      },
      beforeEnter: loadLang,
    },

    {
        path: "/inscripcion/ligaf/:event_id/:lang",
        name: "InscripcionLiga",
        component: InscripcionLiga,
        meta: {
          layout: "inscripcion",
        },
        beforeEnter: loadLang,
    },

    {
      path: "/inscripcion/campus/nike/:event_id/:lang",
      name: "InscripcionCampusNike",
      component: InscripcionNikeCamp,
      meta: {
        layout: "inscripcion",
      },
      beforeEnter: loadLang,
    },

    {
      path: "/inscripcion/campus/miccamp/:event_id/:lang",
      name: "InscripcionCampusNike",
      component: InscripcionNikeCamp,
      meta: {
        layout: "inscripcion",
      },
      beforeEnter: loadLang,
    },

    {
        path: "/inscripcion/campus/miccampen/:event_id/:lang",
        name: "InscripcionCampusNikeEn",
        component: InscripcionNikeCampEn,
        meta: {
          layout: "inscripcion",
        },
        beforeEnter: loadLang,
      },

    {
      path: "/inscripcion/campus/pga/:event_id/:lang",
      name: "InscripcionCampusPGA",
      component: InscripcionPauGasol,
      meta: {
        layout: "inscripcion",
      },
      beforeEnter: loadLang,
    },

    {
      path: "/inscripcion/campus/nikebcn/:event_id/:lang",
      name: "InscripcionCampusNikeBCN",
      component: InscripcionNikeCampBCN,
      meta: {
        layout: "inscripcion",
      },
      beforeEnter: loadLang,
    },

    {
      path: "/inscripcion/campus/miccampbcn/:event_id/:lang",
      name: "InscripcionCampusNikeBCN",
      component: InscripcionNikeCampBCN,
      meta: {
        layout: "inscripcion",
      },
      beforeEnter: loadLang,
    },

    {
      path: "/inscripcion/campus/aitana/:event_id/:lang",
      name: "InscripcionAitana",
      component: InscripcionAitana,
      meta: {
        layout: "inscripcion",
      },
      beforeEnter: loadLang,
    },

    {
      path: "/inscripcion/campus/md/:event_id/:lang",
      name: "InscripcionMundoDeportivo",
      component: InscripcionMundoDeportivo,
      meta: {
        layout: "inscripcion",
      },
      beforeEnter: loadLang,
    },
  ],
});

function loadLang(to, from, next) {
  to.params.lang;

  if (!["ca", "es", "en"].includes(to.params.lang)) {
    to.params.lang = "ca";
  }

  i18n.loadLanguageAsync(to.params.lang).then(function () {
    next();
  });
}
